import type { LucideIcon } from 'lucide-react'
import { Link } from 'react-router-dom'

/** Estado vacío con copy útil — nunca "un cero solo". Transmite que el sistema es
 * selectivo, no que está roto (ver plan de rediseño).
 *
 * P0.56 (Sección 18 del encargo): `cta` opcional -- cada estado vacío debe poder explicar
 * qué puede hacer el usuario a continuación, no solo qué falta. Retrocompatible: los
 * llamadores que solo pasan icon/title/body siguen funcionando idénticos. */
export function EmptyState({
  icon: Icon,
  title,
  body,
  cta,
}: {
  icon: LucideIcon
  title: string
  body: string
  cta?: { label: string; to: string }
}) {
  return (
    <div className="card text-center py-8 px-5 space-y-2.5 animate-fade-in-up motion-reduce:animate-none">
      <Icon className="h-7 w-7 mx-auto text-text-dim" />
      <p className="text-sm font-semibold text-text">{title}</p>
      <p className="text-xs text-text-muted max-w-[32ch] mx-auto leading-relaxed">{body}</p>
      {cta && (
        <Link to={cta.to} className="inline-block text-[10px] font-black uppercase tracking-wider text-brand pt-1">
          {cta.label} →
        </Link>
      )}
    </div>
  )
}
